import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, VertModal } from '@vertem-core/vertice-ds';
import MediaQuery from 'react-responsive';

import OrderItemTracking from '../OrderItemTracking/OrderItemTracking';
import 'Assets/styles/default/components/Orders/OrderDetails/OrderDetailsStyles.less';

import { formatDayMonthYear } from 'Utils/commons/date';
import { useRating } from 'components/RatingProducts/Provider';
import { OrderItemDesktop } from '../components/OrderItemDesktop';
import { OrderItemMobile } from '../components/OrderItemMobile';
import SpotModalTracking from 'components/Spot/SpotTrackingModal';


const OrderItems = ({ order }) => {
  const [ratingModalOpen, setRatingModalOpen] = useState(false);
  const { isEnabled, ratingList, getRatingBySku } = useRating();

  const [isOpenTrackingModal, setIsOpenTrackingModal] = useState(false);
  const [selectedVendorName, setSelectedVendorName] = useState('');
  const [selectedVendorOrderId, setSelectedVendorOrderId] = useState(null);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [selectedVendorShippingValue, setSelectedVendorShippingValue] = useState(0);
  const [isOpenSpotTrackingModal, setIsOpenSpotTrackingModal] = useState(false);
  const [selectedSpotTrackingProductId, setSelectedSpotTrackingProductId] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});
  const [skuTargetForRating, setSkuTargetForRating] = useState();

  const openTrackingModalHandler = (
    vendorName,
    vendorOrderId,
    vendorId,
    vendorShippingValue,
    item,
  ) => {
    if (vendorName && vendorOrderId && vendorId && item) {
      setSelectedVendorName(vendorName);
      setSelectedVendorOrderId(vendorOrderId);
      setSelectedVendorId(vendorId);
      setSelectedVendorShippingValue(vendorShippingValue);
      setSelectedItem(item);
      setIsOpenTrackingModal(true);
    }
  };

  const closeTrackingModalHandler = () => {
    setSelectedVendorName('');
    setSelectedVendorOrderId(null);
    setSelectedVendorId(null);
    setSelectedVendorShippingValue(0);
    setSelectedItem({});
    setIsOpenTrackingModal(false);
  };

  const checkIfOrderWas10DaysAgo = () => {
    if (!order) return false;
    const { createDate } = order;
    if (createDate) {
      const createDateData = new Date(createDate);
      const today = new Date();
      const TenDays = 10 * 24 * 60 * 60 * 1000;
      const timeOut = TenDays + createDateData.getTime();
      return today.getTime() >= timeOut;
    }
    return false;
  };

  useEffect(() => {
    if (
      order &&
      order.vendorOrderModel &&
      order.vendorOrderModel.length &&
      isEnabled &&
      ratingList &&
      getRatingBySku
    ) {
      order.vendorOrderModel.forEach((vendor) => {
        vendor.items.forEach(({ productSkuId: productSku }) => {
          if (!ratingList[productSku]) {
            getRatingBySku(productSku);
          }
        });
      });
    }
  }, [order, isEnabled, ratingList, getRatingBySku]);

  const handleOpenModalTracking = (vendor, item) => {
    const isSpotProduct = item.productSkuId.includes('-PRDT');
    const productSkuId = item.productSkuId.replace('-PRDT', '');

    if (isSpotProduct) {
      setIsOpenSpotTrackingModal(true);
      setSelectedSpotTrackingProductId(productSkuId);
      setSelectedItem(item);

      return;
    }

    openTrackingModalHandler(
      vendor.vendorName,
      vendor.vendorOrderId,

      vendor.vendorId,
      vendor.totalShippingValue,
      item,
    );
  };

  return (
    <Col className='col'>
      <MediaQuery minWidth={769}>
        <OrderItemDesktop
          order={order}
          ratingModalOpen={ratingModalOpen}
          handleChangeModal={(value) => setRatingModalOpen(value)}
          handleOpenModalTracking={handleOpenModalTracking}
          checkIfOrderWas10DaysAgo={checkIfOrderWas10DaysAgo}
          skuTargetForRating={skuTargetForRating}
          handleChangeSkuTarget={(value) => setSkuTargetForRating(value)}
        />
      </MediaQuery>

      <MediaQuery maxWidth={768}>
        <OrderItemMobile
          order={order}
          ratingModalOpen={ratingModalOpen}
          checkIfOrderWas10DaysAgo={checkIfOrderWas10DaysAgo}
          skuTargetForRating={skuTargetForRating}
          handleChangeSkuTarget={(value) => setSkuTargetForRating(value)}
          handleOpenModalTracking={handleOpenModalTracking}
          handleChangeModal={(value) => setRatingModalOpen(value)}
        />
      </MediaQuery>

      {isOpenTrackingModal && (
        <VertModal
          open={isOpenTrackingModal}
          rootClassName='order-details-tracking-modal'
          onCancel={closeTrackingModalHandler}
          title={`Resgate realizado em ${formatDayMonthYear(order.createDate)}`}
          template='marketplace'
          spacing='regular'
        >
          <OrderItemTracking
            item={selectedItem}
            orderDate={order.createDate}
            orderNumber={order.parentOrderId}
            status={order.status}
            vendorName={selectedVendorName}
            vendorOrderId={selectedVendorOrderId}
            vendorId={selectedVendorId}
            vendorShippingValue={selectedVendorShippingValue}
          />
        </VertModal>
      )}

      <SpotModalTracking
        isOpen={isOpenSpotTrackingModal}
        onClose={() => setIsOpenSpotTrackingModal(false)}
        productId={selectedSpotTrackingProductId}
        productData={selectedItem}
        {...order}
      />
    </Col>
  );
};

OrderItems.propTypes = {
  order: PropTypes.array.isRequired,
};

export default OrderItems;
